import React from "react";
import { Mail, Instagram, MapPin, ArrowRight } from "lucide-react";
import { club, heroImages } from "../mock";

export default function Footer() {
  const go = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="relative border-t border-gold/30 pt-16 pb-8 overflow-hidden">
      <div className="absolute inset-0">
        <img src={heroImages.celebrateAlt} alt="team celebration" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/90" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/85 to-black/70" />
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-5">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-4">
              <img src={club.crest} alt="crest" className="h-28 w-28 object-contain drop-shadow-[0_2px_14px_rgba(229,184,51,0.4)]" />
              <div>
                <div className="font-display text-3xl text-white leading-none">ATLÉTICO</div>
                <div className="cond-font text-xs tracking-[0.3em] text-gold mt-1">SOUTH FLORIDA</div>
              </div>
            </div>
            <p className="text-white/55 font-light mt-5 max-w-md">
              A competitive young adult football club focused on high performance, discipline, and
              advancing players to the college and professional level.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a href={`mailto:${club.email}`} className="w-10 h-10 rounded-md border border-white/15 flex items-center justify-center text-white/70 hover:text-gold hover:border-gold transition-colors">
                <Mail size={18} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-md border border-white/15 flex items-center justify-center text-white/70 hover:text-gold hover:border-gold transition-colors">
                <Instagram size={18} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="cond-font uppercase tracking-widest text-sm text-gold mb-4">Explore</h4>
            <ul className="space-y-3">
              {["about", "programs", "coaches", "schedule", "gallery"].map((l) => (
                <li key={l}>
                  <button onClick={() => go(`#${l}`)} className="text-white/60 hover:text-gold transition-colors capitalize font-light">
                    {l}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="cond-font uppercase tracking-widest text-sm text-gold mb-4">Get in touch</h4>
            <div className="flex items-start gap-2 text-white/60 font-light">
              <MapPin size={18} className="text-gold mt-0.5" />
              <span>{club.location}</span>
            </div>
            <div className="flex items-start gap-2 text-white/60 font-light mt-3">
              <Mail size={18} className="text-gold mt-0.5" />
              <a href={`mailto:${club.email}`} className="hover:text-gold transition-colors break-all">{club.email}</a>
            </div>
            <button
              onClick={() => go("#register")}
              className="group inline-flex items-center gap-2 mt-6 bg-gold text-black cond-font uppercase tracking-widest text-sm font-semibold px-5 py-3 rounded-sm hover:bg-gold-light transition-colors"
            >
              Register <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </button>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-sm font-light">© {new Date().getFullYear()} Atlético South Florida. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <a href="/admin" data-testid="footer-admin-login" className="cond-font uppercase tracking-widest text-xs text-white/40 hover:text-gold transition-colors">Login</a>
            <p className="cond-font uppercase tracking-widest text-xs text-white/40">Black · Gold · Ambition</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
